const getLastCharacter = (str: string): string => str?.substring(str.length - 1);

const toNumber = (
  parser: (str: string, radix?: number) => number,
  str: string | undefined | null,
  radix = 10,
): number | undefined => {
  if (str) {
    const number = parser(str, radix);
    if (!Number.isNaN(number)) {
      return number;
    }
  }
  return undefined;
};

const toInt = (str: string | undefined | null, radix = 10): number | undefined =>
  toNumber(Number.parseInt, str, radix);

const toFloat = (str: string | undefined | null): number | undefined =>
  toNumber(Number.parseFloat, str);

const extractTextContentFromHtml = (htmlStr: string): string => {
  const span = document.createElement('span');
  span.innerHTML = htmlStr;
  return span.textContent || span.innerText;
};

const createHtmlSubstring = (htmlStr: string, maxLength: number, showMore = ''): string => {
  // Caution: When shortening the text content, custom styling specified in the text editor will get lost / "cut out".
  const textContent = extractTextContentFromHtml(htmlStr);
  if (textContent.length > maxLength) {
    return textContent.slice(0, maxLength) + showMore;
  }
  return htmlStr;
};

const numberFormatter = (str: string | number, precision = 0): string => {
  const map = [
    { suffix: 'T', threshold: 1e12 },
    { suffix: 'B', threshold: 1e9 },
    { suffix: 'M', threshold: 1e6 },
    { suffix: 'K', threshold: 1e3 },
    { suffix: '', threshold: 1 },
  ];

  const num = Number(str);
  const found = map.find((x) => Math.abs(num) >= x.threshold);
  if (found) {
    return (num / found.threshold).toFixed(precision) + found.suffix;
  }

  return String(num);
};

export const StringUtils = {
  createHtmlSubstring,
  extractTextContentFromHtml,
  getLastCharacter,
  toInt,
  toFloat,
  numberFormatter,
};
